module.exports = __webpack_public_path__ + "img/card2@2x.fac18aca.png";